import React from "react";
import Modal from "react-modal";
import classNames from "classnames";
import Image from "next/image";
import successMail from "@/images/svg/successMail.svg";
interface SuccessModalProps {
  onClose: any;
  isOpen: boolean;
  email: string;
}
export default function SuccessModal({
  onClose,
  isOpen,
  email,
}: SuccessModalProps) {
  return (
    <Modal
      ariaHideApp={false}
      onRequestClose={onClose}
      isOpen={isOpen}
      closeTimeoutMS={100}
    >
      <div
        className={classNames("content md:w-[416px] w-full p-4 bg-[#F8FAFC]")}
      >
        <div className="flex items-center justify-center pb-2 box-border">
          <Image
            src={successMail}
            width={64}
            height={64}
            alt={"checkbox"}
            className={"object-contain"}
          />
        </div>
        <p className="text-center text-base text-main-black font-bold mb-2">
          We sent the job application link to
          <br />
          {email}
        </p>
        <p className="text-center text-main-black text-xs">
          Please check your inbox and spam folder.
        </p>
      </div>
    </Modal>
  );
}
